import { MonetateEnums } from '@enums/monetate-enums';

export const setPageType = () => {
  if (window) {
    window.monetateQ = window.monetateQ || [];
    window.monetateQ.push(['setPageType', MonetateEnums.Cart]);
  }
};

export const trackCart = (basket) => {
  if (window) {
    window.monetateQ = window.monetateQ || [];
    if (!basket) return;
    const items = basket.lineItems?.map((x) => ({
      productId: x.sku,
      quantity: x.quantity,
      unitPrice: x.price?.toString(),
      currency: basket.currency,
    }));
    window.monetateQ.push(['addCartRows', items]);
    window.monetateQ.push(['trackData']);
  }
};
